<template>
  <div class="sw-grid-flex sw-grid-flex--dir-column">
    <div class="sw-grid-flex sw-grid-flex--wrap sw-grid-flex--align-center">
        <div
          v-for="item in printabilityChecks"
          :key="'check-' + item.id"
          class="sw-grid-flex__cell-1-4 sw--padding-2">
          <input
            type="checkbox"
            :id="item.id"
            :value="item.id"
            v-model="selectedChecks"
            :disabled="missingInformation.length > 0">
          <label
            :class="missingInformation.length > 0 ? 'sw-dms--color-grey-64' : ''"
            :for="item.id">{{item.name}}{{item.isOptional == 0? ' (required)': ''}}
          </label>
        </div>
      <div
        v-if="missingInformation.length <= 0"
        class="sw-grid-flex__cell-1-1 sw--padding-vert-2">
        <button
          v-if="allSelected"
          @click="unselectAll"
          class="sw-dms-button sw-dms-button--big sw--float-right sw--cursor-pointer">
          Unselect All
        </button>
        <button
          v-else
          @click="selectAll"
          class="sw-dms-button sw-dms-button--big sw--float-right sw--cursor-pointer">
          Select All
        </button>
      </div>
      </div>
    <bottom-banner
      :missing-info="missingInformation"
      v-on:saved="savePrintability"
      :show-saved-message="showSavedMessage" />
  </div>
</template>

<script>
    import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
    import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
    import BottomBanner from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/BottomBannerComponent/bottom-banner";
    export default {
        name: "material-printability",
        components: {BottomBanner},
        mixins: [VueSwMixin, VueJQueryMixin],
        props: {
            printabilityChecks: {
                type:Array,
                required: true,
            },
             printerTechnologyIds: {
                type: Array,
                 required: false,
             },
            materialId: {
                type: Number,
                required: false
            },
            currentMaterial: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => ({
            selectedChecks: [],
            showSavedMessage: false
        }),
        created() {

            if(this.currentMaterial) {
                this.selectedChecks = this.currentMaterial.printabilityCheckIds;
            } else {
                this.printabilityChecks.forEach(check => {
                    if (check.isOptional == 0) {
                        this.selectedChecks.push(check.id);
                    }
                })
            }
        },
        computed: {
            allSelected() {
                return this.printabilityChecks.length === this.selectedChecks.length;
            },
            missingInformation() {
                let missingInfo = [];
                if (!this.materialId) {
                    missingInfo.push('Basic Information')
                }
                if (!this.printerTechnologyIds || this.printerTechnologyIds.length <= 0) {
                    missingInfo.push('Printers')
                }
                return missingInfo;
            }
        },
        methods: {
            selectAll() {
                this.selectedChecks = [];
                this.printabilityChecks.forEach(item => {
                    this.selectedChecks.push(item.id)
                });
                return this.selectedChecks;
            },
            unselectAll() {
                this.selectedChecks = [];
                this.printabilityChecks.forEach(check => {
                    if (check.isOptional == 0) {
                        this.selectedChecks.push(check.id);
                    }
                })
            },
            savePrintability() {
                let _this = this;
                this.$jQuery.ajax({
                    type: 'POST',
                    url: '/admin/material/' + _this.materialId + '/printability',
                    dataType: 'json',
                    data: {
                        printabilityCheckIds: _this.selectedChecks,
                        printerTechnologyMaterialIds: _this.printerTechnologyIds
                    },
                    success: (data) => {
                        _this.$emit('success', data);
                        _this.showSavedMessage = true;
                        this.$sw.notifications.success('Saved!')
                    },
                    error: (jqXHR) => {
                        const response = JSON.parse(jqXHR.responseText);
                        _this.errorMessage = response.message;
                        _this.$emit('error', jqXHR);
                    }
                });

            }
        }
    }
</script>
